import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isBlindsOpen, setIsBlindsOpen] = useState(false);
  const [isShadesOpen, setIsShadesOpen] = useState(false);
  const [isBrowseOpen, setIsBrowseOpen] = useState(false);


  const toggleRef = useRef(null);
  const sidebarRef = useRef(null);
  
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({
    need: false,
    shades: false,
    blinds: false,
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMenu = (menu) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          isSidebarOpen &&
          sidebarRef.current &&
          !sidebarRef.current.contains(event.target) &&
          !toggleRef.current.contains(event.target)
        ) {
          setIsSidebarOpen(false);
        }
      };
      // Add event listener to document
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Cleanup the event listener
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isSidebarOpen]);



  const handleMouseEnter = (menu) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
    setHoveredMenu(menu);
  };

  const handleMouseLeave = () => {
    const id = setTimeout(() => {
      setHoveredMenu(null);
    }, 300); // Delay before closing the dropdown
    setTimeoutId(id);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const toggleBlindsMenu = () => {
    setIsBlindsOpen((prev) => !prev);
  };

  const toggleShadesMenu = () => {
    setIsShadesOpen((prev) => !prev);
  };

  const toggleBrowseMenu = () => {
    setIsBrowseOpen((prev) => !prev);
  };

  return (
    <header  className= " bg-black text-[#ffffff]  w-full z-70">
    <div className="flex items-center justify-between py-4 px-6 xl:px-20 w-full">
  {/* Logo */}
  <a href="/" className="flex items-center">
    <img src="images/logo.png" alt="Logo" className="h-12 lg:h-14" />
  </a>

  {/* Desktop Navigation */}
  <nav className="relative hidden lg:flex items-center gap-x-10 xl:gap-x-12 2xl:gap-x-14 overflow-visible z-50">
    
    {/* Shades */}
    <div className="relative group">
      <button className="font-semibold text-sm 2xl:text-lg uppercase hover:text-gray-300 transition duration-300 peer">
        Shades
      </button>
      <ul className="absolute left-1/2 transform -translate-x-1/2  bg-[#1c1b1b] rounded-lg text-xl text-white text-center w-72 min-w-max shadow-lg opacity-0 invisible transition-all duration-300 z-50 
    group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto pointer-events-none">
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/romanshades">Roman Shades</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/rollershades">Roller Shades</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/wovenshades">Woven Shades</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/verticalshades">Vertical Shades</Link>
        </li>
      </ul>
    </div>

    {/* Blinds */}
    <div className="relative group">
      <button className="font-semibold text-sm 2xl:text-lg uppercase hover:text-gray-300 transition duration-300 peer">
        Blinds
      </button>
      <ul className="absolute left-1/2 transform -translate-x-1/2  bg-[#1c1b1b] rounded-lg text-xl text-white text-center w-72 min-w-max shadow-lg opacity-0 invisible transition-all duration-300 z-50 
    group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto pointer-events-none">
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/zebreblinds">Zebra Blinds</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/rollerblinds">Roller Blinds</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/woodenblinds">Wooden Blinds</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/tripleblinds">Triple Shade Blinds</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/shangblinds">Shang ri-la Blinds</Link>
        </li>
      </ul>
    </div>

    {/* Motorization */}
    <a href="/motarization" className="text-sm 2xl:text-lg font-semibold hover:text-gray-300 transition duration-300">
      MOTORIZATION
    </a>

    {/* Browse by Need */}
    <div className="relative group">
      <button className="font-semibold text-sm 2xl:text-lg uppercase hover:text-gray-300 transition duration-300">
        BROWSE BY NEED
      </button>
      <ul className="absolute left-1/2 transform -translate-x-1/2  bg-[#1c1b1b] rounded-lg text-xl text-white text-center w-72 min-w-max shadow-lg opacity-0 invisible transition-all duration-300 z-50 
    group-hover:opacity-100 group-hover:visible group-hover:pointer-events-auto pointer-events-none">
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/roombright">Room Brightening</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/roomdarkening">Room Darkening</Link>
        </li>
        <li className="px-4 py-3 hover:bg-gray-600">
          <Link to="/energyefficient">Energy Efficient</Link>
        </li>
      </ul>
    </div>

    {/* Catalogues */}
    <a href="/catelogs" className="text-sm 2xl:text-lg font-semibold hover:text-gray-300 transition duration-300">
      CATALOGUES
    </a>

    {/* Contact Us */}
    <a href="/contactus" className="text-sm 2xl:text-lg font-semibold hover:text-gray-300 transition duration-300">
      CONTACT US
    </a>
  </nav>

  {/* Book Now Button */}
  <a
    href="/contactus"
    className="hidden lg:block border-2 border-[#ffffff] text-[#ffffff] text-sm 2xl:text-lg font-semibold px-4 py-1 hover:border-[#9e7f52] transition duration-300"
  >
    BOOK NOW
  </a>
</div>


{/* mobile menu bar */}
        <header>
      <nav className="flex items-center justify-between">
        {/* Hamburger Menu */}
        <div className="absolute top-2 right-0 md:right-10">
          <button
            onClick={toggleSidebar}
            ref={toggleRef}
            className="p-4 lg:hidden relative z-30"
          >
            <i
              className="fa fa-bars text-white text-3xl md:text-4xl"
              aria-hidden="true"
            ></i>
          </button>
        </div>

        {/* Sidebar */}
        <div
          ref={sidebarRef}
          className={`xl:hidden fixed top-20 right-0 w-60 px-4 rounded-tl-lg rounded-bl-lg bg-black text-white z-50 transform transition-transform duration-300 ease-in-out ${
            isSidebarOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <ul className="p-2 text-center font-alumni text-xl space-y-4">
            {/* Main Options */}
            <li>
              <button
                onClick={() => toggleMenu("shades")}
                className="flex justify-center gap-3 w-full py-2 font-mono"
              >
                Shades
                <span>{expandedMenus.shades ? "-" : "+"}</span>
              </button>
              <ul
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  expandedMenus.shades
                    ? "max-h-80 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                {/* <li>
                  <Link to="/aurashades" className="block py-1 pl-4">
                    Aura Illuminated Shades
                  </Link>
                </li>
                <li>
                  <Link to="/sheershades" className="block py-1 pl-4">
                    Sheer Shades
                  </Link>
                </li> */}
                <li>
                  <Link to="/romanshades" className="block py-1 pl-4">
                    Roman Shade
                  </Link>
                </li>
                <li>
                  <Link to="/rollershades" className="block py-1 pl-4">
                    Roller Shade
                  </Link>
                </li>
                <li>
                  <Link to="/wovenshades" className="block py-1 pl-4">
                    Woven Shades
                  </Link>
                </li>
                <li>
                  <Link to="/verticalshades" className="block py-1 pl-4">
                    Vertical Shades
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <button
                onClick={() => toggleMenu("blinds")}
                className="flex justify-center gap-3 w-full py-2 font-mono"
              >
                Blinds
                <span>{expandedMenus.blinds ? "-" : "+"}</span>
              </button>
              <ul
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  expandedMenus.blinds
                    ? "max-h-60 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <li>
                  <Link to="/zebreblinds" className="block py-1 pl-4">
                    Zebra Blinds
                  </Link>
                </li>
                <li>
                  <Link to="/rollerblinds" className="block py-1 pl-4">
                    Roller Blinds
                  </Link>
                </li>
                <li>
                  <Link to="/woodenblinds" className="block py-1 pl-4">
                    Wooden Blinds
                  </Link>
                </li>
                <li>
                  <Link to="/tripleblinds" className="block py-1 pl-4">
                    Triple Shade Blinds
                  </Link>
                </li>
                <li>
                  <Link to="/shangblinds" className="block py-1 pl-4">
                    Shangri-La Blinds
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/motarization" className="block py-2 font-mono">
                Motorization
              </Link>
            </li>
            <li>
              <button
                onClick={() => toggleMenu("need")}
                className="flex justify-between w-full py-2 font-mono"
              >
                Browse by Need
                <span>{expandedMenus.need ? "-" : "+"}</span>
              </button>
              <ul
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  expandedMenus.need ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <li>
                  <Link to="/roombright" className="block py-1 pl-4">
                    Room Brightening
                  </Link>
                </li>
                <li>
                  <Link to="/roomdarkening" className="block py-1 pl-4">
                    Room Darkening
                  </Link>
                </li>
                <li>
                  <Link to="/energyefficient" className="block py-1 pl-4">
                    Energy Efficient
                  </Link>
                </li>
              </ul>
            </li>
          
            <li>
              <Link to="/contactus" className="block py-2 font-mono">
                Contact Us
              </Link>
            </li>
            
            <li>
              <Link to="/catelogs" className="block py-2 font-mono">
              Catalogue
              </Link>
            </li>
            <li>
              <Link to="/contactus" className="block py-2 font-mono">
                Book Now
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    </header>
  );
};

export default Header;

// import React, { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';

// const Header = () => {
//   const [hoveredMenu, setHoveredMenu] = useState(null);
//   const [timeoutId, setTimeoutId] = useState(null);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isBlindsOpen, setIsBlindsOpen] = useState(false);
//   const [isShadesOpen, setIsShadesOpen] = useState(false);
//   const [isBrowseOpen, setIsBrowseOpen] = useState(false);


//   const toggleRef = useRef(null);
//   const sidebarRef = useRef(null);
  
  
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [expandedMenus, setExpandedMenus] = useState({
//     need: false,
//     shades: false,
//     blinds: false,
//   });

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const toggleMenu = (menu) => {
//     setExpandedMenus((prev) => ({
//       ...prev,
//       [menu]: !prev[menu],
//     }));
//   };
    
  
   
  
    
//     useEffect(() => {
//       const handleClickOutside = (event) => {
//         if (
//           isSidebarOpen &&
//           sidebarRef.current &&
//           !sidebarRef.current.contains(event.target) &&
//           !toggleRef.current.contains(event.target)
//         ) {
//           setIsSidebarOpen(false);
//         }
//       };
//       // Add event listener to document
//       document.addEventListener('mousedown', handleClickOutside);
//       return () => {
//         // Cleanup the event listener
//         document.removeEventListener('mousedown', handleClickOutside);
//       };
//     }, [isSidebarOpen]);



//   const handleMouseEnter = (menu) => {
//     if (timeoutId) {
//       clearTimeout(timeoutId);
//       setTimeoutId(null);
//     }
//     setHoveredMenu(menu);
//   };

//   const handleMouseLeave = () => {
//     const id = setTimeout(() => {
//       setHoveredMenu(null);
//     }, 300); // Delay before closing the dropdown
//     setTimeoutId(id);
//   };

//   const toggleMobileMenu = () => {
//     setIsMobileMenuOpen((prev) => !prev);
//   };

//   const toggleBlindsMenu = () => {
//     setIsBlindsOpen((prev) => !prev);
//   };

//   const toggleShadesMenu = () => {
//     setIsShadesOpen((prev) => !prev);
//   };

//   const toggleBrowseMenu = () => {
//     setIsBrowseOpen((prev) => !prev);
//   };

//   return (
//     <header  className= "  font-playfair   bg-black text-[#EDE3D4]  w-full z-50">
//       <div className="container mx-auto flex items-center justify-between py-4 px-6">
//         {/* Logo */}
//         <a href="/" className="flex items-center">
//           <img src="images/logo.png" alt="Logo" className="h-12 lg:h-14" />
//         </a>

//         {/* Desktop Navigation */}
//         <nav className="hidden z-50 lg:flex absolute left-1/2 transform -translate-x-1/2 gap-6 2xl:gap-12">
//           {/* Motorization */}
//           <a href="/motarization" className="text-base 2xl:text-lg font-bold hover:text-gray-300 transition duration-300">
//             MOTORIZATION
//           </a>

//           {/* Browse by Need */}
//         {/* Browse by Need */}
// <div
//   className="dropdown relative"
//   onMouseEnter={() => handleMouseEnter('browse')}
//   onMouseLeave={handleMouseLeave}
// >
//   <button className="text-base 2xl:text-lg font-bold hover:text-gray-300 transition duration-300 flex items-center">
//     BROWSE BY NEED
//   </button>
//   {hoveredMenu === 'browse' && (
//     <ul className="absolute left-1/2 transform -translate-x-1/2 mt-2 bg-[#1c1b1b] rounded-lg text-xl font-anek text-white text-center w-72 z-50 shadow-lg">
//       <li className="px-4 py-3 hover:bg-gray-600">
//         <Link to="/roombright">Room Brightening</Link>
//       </li>
//       {/* <li className="px-4 py-3 hover:bg-gray-600">
//         <Link to="/lightenhancing">Light Enhancing</Link>
//       </li> */}
//       <li className="px-4 py-3 hover:bg-gray-600">
//         <Link to="/roomdarkening">Room Darkening</Link>
//       </li>
//       <li className="px-4 py-3 hover:bg-gray-600">
//         <Link to="/energyefficient">Energy Efficient</Link>
//       </li>
//       <li className="px-4 py-3 hover:bg-gray-600">
//         <Link to="/">Door Coverings</Link>
//       </li>
//       <li className="px-4 py-3 hover:bg-gray-600">
//         <Link to="/">Sound Absorption</Link>
//       </li>
//       <li className="px-4 py-3 hover:bg-gray-600">
//         <Link to="/">Commercial Solutions</Link>
//       </li>
//     </ul>
//   )}
// </div>


//           {/* Shades */}
//           <div
//             className="dropdown relative "
//             onMouseEnter={() => handleMouseEnter('shades')}
//             onMouseLeave={handleMouseLeave}
//           >
//             <button className="text-base t2xl:text-lg font-bold uppercase hover:text-gray-300 transition duration-300 flex items-center">
//               Shades
//             </button>
//             {hoveredMenu === 'shades' && (
//               <ul className="absolute left-1/2 transform -translate-x-1/2 mt-2 bg-[#1c1b1b] font-anek rounded-lg text-xl text-white text-center w-72 z-50 shadow-lg">
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/aurashades">Aura Illuminated Shades</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/sheershades">Sheer Shades</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/cellularshades">Cellular Shades</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/romanshades">Roman Shades</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/rollershades">Roller Shades</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/wovenshades">Woven Shades</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/verticalshades">Vertical Shades</Link>
//                 </li>
//               </ul>
//             )}
//           </div>

//           {/* Blinds */}
//           <div
//             className="dropdown relative"
//             onMouseEnter={() => handleMouseEnter('blinds')}
//             onMouseLeave={handleMouseLeave}
//           >
//             <button className="uppercase font-bold text-base 2xl:text-lg hover:text-gray-300 transition duration-300 flex items-center">
//               Blinds
//             </button>
//             {hoveredMenu === 'blinds' && (
//               <ul className="absolute left-1/2 transform -translate-x-1/2 mt-2 bg-[#1c1b1b] font-anek rounded-lg text-xl text-white text-center w-72 z-50 shadow-lg">
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/zebreblinds">Zebra Blinds</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/rollerblinds">Roller Blinds</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/woodenblinds">Wooden Blinds</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/tripleblinds">Triple Shade Blinds</Link>
//                 </li>
//                 <li className="px-4 py-3 hover:bg-gray-600">
//                   <Link to="/shangblinds">Shang ri-la Blinds</Link>
//                 </li>
//               </ul>
//             )}
//           </div>

//           {/* Contact Us */}
//           <a href="/" className="text-base 2xl:text-lg font-bold hover:text-gray-300 transition duration-300">
// CONTACT US          </a>
//         </nav>

//         {/* Book Now Button */}
//         <a
//           href="/"
//           className="hidden text-base 2xl:text-lg lg:block border-2 border-[#ac9b82] text-[#EDE3D4] font-bold px-4 py-3  hover:border-[#9e7f52] transition duration-300"
//         >
// BOOK NOW        </a>

// </div>



//         {/* Mobile Hamburger Menu */}
        
      
//         <header>
//       <nav className="flex items-center justify-between">
//         {/* Hamburger Menu */}
//         <div className="absolute top-2 right-0 md:right-10">
//           <button
//             onClick={toggleSidebar}
//             ref={toggleRef}
//             className="p-4 lg:hidden relative z-30"
//           >
//             <i
//               className="fa fa-bars text-white text-3xl md:text-4xl"
//               aria-hidden="true"
//             ></i>
//           </button>
//         </div>

//         {/* Sidebar */}
//         <div
//           ref={sidebarRef}
//           className={`xl:hidden fixed top-20 right-0 w-60 px-4 rounded-tl-lg rounded-bl-lg bg-black text-white z-50 transform transition-transform duration-300 ease-in-out ${
//             isSidebarOpen ? "translate-x-0" : "translate-x-full"
//           }`}
//         >
//           <ul className="p-2 text-center font-alumni text-xl space-y-4">
//             {/* Main Options */}
//             <li>
//               <Link to="/" className="block py-2 font-mono">
//                 Motorization
//               </Link>
//             </li>
//             <li>
//               <button
//                 onClick={() => toggleMenu("need")}
//                 className="flex justify-between w-full py-2 font-mono"
//               >
//                 Browse by Need
//                 <span>{expandedMenus.need ? "-" : "+"}</span>
//               </button>
//               <ul
//                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
//                   expandedMenus.need ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
//                 }`}
//               >
//                 <li>
//                   <Link to="/need1" className="block py-1 pl-4">
//                     Room Brightening
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/need2" className="block py-1 pl-4">
//                     Room Darkening
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/need3" className="block py-1 pl-4">
//                     Energy Efficient
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/need4" className="block py-1 pl-4">
//                     Door Coverings
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/need5" className="block py-1 pl-4">
//                     Sound Absorption
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/need6" className="block py-1 pl-4">
//                     Commercial Solutions
//                   </Link>
//                 </li>
//               </ul>
//             </li>
//             <li>
//               <button
//                 onClick={() => toggleMenu("shades")}
//                 className="flex justify-between w-full py-2 font-mono"
//               >
//                 Shades
//                 <span>{expandedMenus.shades ? "-" : "+"}</span>
//               </button>
//               <ul
//                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
//                   expandedMenus.shades
//                     ? "max-h-80 opacity-100"
//                     : "max-h-0 opacity-0"
//                 }`}
//               >
//                 <li>
//                   <Link to="/shade1" className="block py-1 pl-4">
//                     Aura Illuminated Shades
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/shade2" className="block py-1 pl-4">
//                     Sheer Shades
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/shade3" className="block py-1 pl-4">
//                     Cellular Shade
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/shade4" className="block py-1 pl-4">
//                     Roman Shade
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/shade5" className="block py-1 pl-4">
//                     Roller Shade
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/shade6" className="block py-1 pl-4">
//                     Woven Shades
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/shade7" className="block py-1 pl-4">
//                     Vertical Shades
//                   </Link>
//                 </li>
//               </ul>
//             </li>
//             <li>
//               <button
//                 onClick={() => toggleMenu("blinds")}
//                 className="flex justify-between w-full py-2 font-mono"
//               >
//                 Blinds
//                 <span>{expandedMenus.blinds ? "-" : "+"}</span>
//               </button>
//               <ul
//                 className={`transition-all duration-300 ease-in-out overflow-hidden ${
//                   expandedMenus.blinds
//                     ? "max-h-60 opacity-100"
//                     : "max-h-0 opacity-0"
//                 }`}
//               >
//                 <li>
//                   <Link to="/blind1" className="block py-1 pl-4">
//                     Zebra Blinds
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/blind2" className="block py-1 pl-4">
//                     Roller Blinds
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/blind3" className="block py-1 pl-4">
//                     Wooden Blinds
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/blind4" className="block py-1 pl-4">
//                     Triple Shade Blinds
//                   </Link>
//                 </li>
//                 <li>
//                   <Link to="/blind5" className="block py-1 pl-4">
//                     Shangri-La Blinds
//                   </Link>
//                 </li>
//               </ul>
//             </li>
//             <li>
//               <Link to="/contact" className="block py-2 font-mono">
//                 Contact Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/donation" className="block py-2 font-mono">
//                 Book Now
//               </Link>
//             </li>
//           </ul>
//         </div>
//       </nav>
//     </header>



   
//     </header>
//   );
// };

// export default Header;







